import React from 'react';

class CalendarModal extends React.Component {
  constructor(props){
    super(props);
  }
  render(){
    return (
      <div className="p-30">
        <div data-tockify-component="calendar" data-tockify-calendar="explorelive"></div>
      </div>
    );
  }
}

export default CalendarModal;
